import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import SendUsAMessage from "./sections/SendUsAMessage";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <Contact />
      <SendUsAMessage />
      <Faq />
      <Footer />
    </div>;
}